import { create } from 'zustand';

type AlertType = {
  type: 'error' | 'warning' | 'success';
  text: string;
  id: string;
};

type State = {
  alerts: AlertType[];
};

type NotifyType = {
  text: AlertType['text'];
  type: AlertType['type'];
};

type Action = {
  notify: (props: NotifyType | NotifyType[]) => void;
  clearAlerts: () => void;
};

let TOAST_ID = 0;
const genToastId = () => {
  TOAST_ID += 1;

  return `${TOAST_ID}`;
};

export const useAlertToast = create<State & Action>(set => ({
  alerts: [],
  notify: input => {
    const messages = Array.isArray(input) ? input : [input];
    set(({ alerts }) => ({
      alerts: [
        ...alerts.slice(-10),
        ...messages.map(m => ({
          type: m.type,
          text: m.text,
          id: genToastId(),
        })),
      ],
    }));
  },
  clearAlerts: () => {
    set(() => ({ alerts: [] }));
  },
}));
